module.exports = __webpack_public_path__ + "img/close.d3798c33.svg";